// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0098adef","455":"403eaf1d","946":"aa9d3ee9"}[chunkId] + ".chunk.js";
};